import { ModuleCategoryEnum } from "../modules/ModuleModel";

export class Category {
  id?: string;
  name: string;

  constructor(data: Partial<Category | any> = {}) {
    this.id = data.id;
    this.name = data.name;
  }
}

export class Station {
  id?: string;
  name: string;

  constructor(data: Partial<Station | any> = {}) {
    this.id = data.id;
    this.name = data.name;
  }
}

export class StationOrderItem {
  productId: string;
  name: string;
  quantity: number;
  status: string;
  comments: string;

  constructor(data: Partial<any> = {}) {
    this.productId = data.productId;
    this.name = data.name;
    this.quantity = data.quantity;
    this.status = data.status;
    this.comments = data.comments;
  }
}

export class StationOrderModel {
  id: string;
  stationId: string;
  stationName: string;
  moduleId: string;
  orderId: string;
  items: StationOrderItem[];
  companyCode: string;
  storeCode: string;
  createdAt: number;
  moduleName: string;
  moduleCategory: ModuleCategoryEnum;

  constructor(data: Partial<any> = {}) {
    this.id = data.id;
    this.stationId = data.stationId;
    this.stationName = data.stationName;
    this.moduleId = data.moduleId;
    this.orderId = data.orderId;
    this.items = (data.items || []).map((i: any) => new StationOrderItem(i));
    this.companyCode = data.companyCode;
    this.storeCode = data.storeCode;
    this.createdAt = data.createdAt;
    this.moduleName = data.moduleName;
    this.moduleCategory = data.moduleCategory;
  }
}

export class Product {
  id?: string;
  name: string;
  categoryId: string;
  stations: string[];
  unit: string;
  minQuantity: number;
  cost: number;
  salePrice: number;
  suggestions: string[];

  constructor(data: Partial<Product> | any = {}) {
    this.id = data.id;
    this.name = data.name;
    this.categoryId = data.categoryId;
    this.stations = data.stations;
    this.unit = data.unit;
    this.minQuantity = data.minQuantity;
    this.cost = data.cost;
    this.salePrice = data.salePrice;
    this.suggestions = data.suggestions;
  }
}
